module.exports = "<div class=\"condition-wrapper\">\n  <div class=\"condition-col\" *ngFor=\"let condition of conditions; let idx = index\">\n      <app-condition-col [columnData]=\"condition\" [index]=\"idx\" [rowIndex]=\"index\"></app-condition-col>\n  </div>\n</div>\n\n<span class=\"cnod-toggle\" [ngClass]=\"{'or': isOrOperator()}\" (click)=\"toggleOperator()\"\n      *ngIf=\"row.logicalConnector\"> {{row.logicalConnector | logicalOperator}}</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/new-rule/condition-row/condition-row.component.html
// module id = 1434
// module chunks = 1